<template>
<div class="tab-container">
  <van-tabs type="card">
    <van-tab :title="'进行中的任务(' + task_cnt + ')'">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <van-panel
          v-for="item in list"
          :key="item"
          :title="item.title"
          :desc="item.reward"
          icon="underway"
          class="task_detail">
          <div slot="footer">
            <van-cell :title="item.due_time" />
          </div>
        </van-panel>
      </van-list>
    </van-tab>
</div>
</template>

<script>
import { Icon, Cell, Panel, Circle, Tab, Tabs, List } from "vant";

export default {
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Panel.name]: Panel,
    [Circle.name]: Circle,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      task_cnt: "-",
      pn: 0,
      ps: 8
    };
  },
  methods: {
    loadTasks(openid) {
      this.$http
        .get("https://cb.xhare.cn/tasks", {
          params: { openid: openid, pn: this.pn, ps: this.ps }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              if (this.pn == 0) {
                this.task_cnt = "" + res.data.count;
              }
              if (res.data.data.length < this.ps) {
                this.finished = true;
              }
              if (res.data.data.length > 0) {
                res.data.data.forEach(element => {
                  this.list.push({
                    title: "[" + element.progress + "]" + element.title,
                    due_time: "到期时间：" + element.due_time,
                    reward: element.reward,
                  });
                });
              }

              this.loading = false;
            }
            this.pn++;
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    redirect() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/%23task&response_type=code&scope=snsapi_base&state=ucenter";
    },
    onLoad() {
      let openid = sessionStorage.getItem("openid");
      if (openid) {
        this.loadTasks(openid);
      } else {
        this.$http
          .get("https://cb.xhare.cn/openid", {
            params: {
              code: (window.location.search
                .substr(1)
                .match(/(^|&)code=([^&]*)(&|$)/i) || [])[2]
            }
          })
          .then(
            function(res) {
              if (res.data.openid == "") {
                this.redirect();
              } else {
                this.loadTasks(res.data.openid);
                sessionStorage.setItem("openid", res.data.openid);
              }
            }.bind(this)
          )
          .catch(
            function() {
              this.redirect();
            }.bind(this)
          );
      }
    }
  }
};
</script>

<style lang="less">
.task_detail {
  .van-cell__label {
    font-size: 20px;
  }
  .van-panel__footer {
    padding: 0;
  }
  .van-cell {
    color: red;
  }
}
</style>
